import classNames from 'classnames';
import { HeaderGroup } from 'components/ui-blocks/header';
import React from 'react';

import styles from './ModalHeaderGroup.module.scss';

interface Props {
  children: React.ReactNode;
  autoGrow?: boolean;
  title?: boolean;
  centerText?: boolean;
  style?: React.CSSProperties;
}
const ModalHeaderGroup = (props: Props) => (
  <HeaderGroup
    autoGrow={props.autoGrow}
    className={classNames({
      [styles.modalTitle]: props.title,
      [styles.centered]: props.centerText,
    })}
    style={props.style}
  >
    {props.children}
  </HeaderGroup>
);
export default ModalHeaderGroup;
